import { ReactNode, useEffect, useState } from 'react'

import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'

interface ScalrCarouselProps {
  children: ReactNode[]
  fitMoreCard?: boolean
}

export function ScalrCarousel({
  children,
  fitMoreCard = false,
}: ScalrCarouselProps) {
  const [api, setApi] = useState<CarouselApi>()
  const [current, setCurrent] = useState(0)
  const [count, setCount] = useState(0)

  useEffect(() => {
    if (!api) {
      return
    }

    const handleSelect = () => {
      setCurrent(api.selectedScrollSnap())
    }

    const handleResize = () => {
      setCount(api.scrollSnapList().length)
    }

    setCount(api.scrollSnapList().length)
    setCurrent(api.selectedScrollSnap())

    api.on('select', handleSelect)
    api.on('resize', handleResize)

    return () => {
      api.off('select', handleSelect)
      api.off('resize', handleResize)
    }
  }, [api])

  return (
    <Carousel setApi={setApi} className="mb-6">
      <CarouselContent>
        {children.map((child, index) => (
          <CarouselItem
            className={`basis-full ${fitMoreCard ? 'md:basis-1/5 sm:basis-1/3' : 'md:basis-1/3 sm:basis-1/2'}`}
            key={index}
          >
            {child}
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious />
      <CarouselNext />
      <div className="absolute left-1/2 -translate-x-1/2 flex gap-2 mt-2">
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            className={`rounded-full transition-colors ${
              current === index ? 'h-2 w-4 bg-blue-500' : 'h-2 w-2 bg-black-50'
            }`}
          />
        ))}
      </div>
    </Carousel>
  )
}
